import { Routes } from '@angular/router';
import { StartComponent } from './pages/start/start.component';
import { TrainingComponent } from './pages/training/training.component';
import { LearningComponent } from './pages/training/learning/learning.component';
import { PracticeComponent } from './pages/training/practice/practice.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { ParentLernComponent } from './pages/training/learning/parent-lern/parent-lern.component';
import { AdultLernComponent } from './pages/training/learning/adult-lern/adult-lern.component';
import { ChildLernComponent } from './pages/training/learning/child-lern/child-lern.component';
import { MainComponent } from './components/layouts/main/main.component';
import { ROUTES_CONST } from './const/menu';
import { TicketComponent } from './pages/training/practice/ticket/ticket.component';
// import { EgoChatComponent } from './pages/ego-chat/ego-chat.component';

export const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: ROUTES_CONST.START,
        component: StartComponent,
      },
      // {
      //   path: ROUTES_CONST.EGO_CHAT,
      //   component: EgoChatComponent,
      // },
      {
        path: ROUTES_CONST.TRAINING,
        component: TrainingComponent,
        children: [
          {
            path: ROUTES_CONST.LEARNING,
            children: [
              {
                path: ROUTES_CONST.PARENT_LEARN,
                component: ParentLernComponent,
              },
              {
                path: ROUTES_CONST.ADULT_LEARN,
                component: AdultLernComponent,
              },
              {
                path: ROUTES_CONST.CHILD_LEARN,
                component: ChildLernComponent,
              },
              {
                path: '',
                redirectTo: ROUTES_CONST.PARENT_LEARN,
                pathMatch: 'full',
              },
            ],
            component: LearningComponent,
          },
          {
            path: ROUTES_CONST.PRACTICE,
            component: PracticeComponent,
          },

          { path: '', redirectTo: ROUTES_CONST.LEARNING, pathMatch: 'full' },
        ],
      },
      {
        path: ROUTES_CONST.TICKET + '/:ticketId',
        component: TicketComponent,
      },
      {
        path: ROUTES_CONST.PRACTICE,
        component: PracticeComponent,
      },
      { path: ROUTES_CONST.SETTINGS, component: SettingsComponent },
      { path: ROUTES_CONST.PARENT_LEARN, component: ParentLernComponent },
      { path: ROUTES_CONST.ADULT_LEARN, component: AdultLernComponent },
      { path: ROUTES_CONST.CHILD_LEARN, component: ChildLernComponent },
    ],
  },
];
